import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { selectIsAdminRoute, selectRouteBoardId, selectRouteOrganisationId } from './router.selectors';

@Injectable({ providedIn: 'root' })
export class RouterFacadeService {
  private _store = inject(Store);

  boardId = <Signal<string>>toSignal(this._store.select(selectRouteBoardId));

  isAdminRoute = <Signal<boolean>>toSignal(this._store.select(selectIsAdminRoute));

  tenantId = <Signal<string>>toSignal(this._store.select(selectRouteOrganisationId));
}
